export const companies = [
  {
    id: 'acdenBeeclean',
    name: 'ACDEN BEECLEAN',
    isActive: true
  },
  {
    id: 'acdenEnvironment',
    name: 'ACDEN ENVIRONMENT',
    isActive: true
  },
  {
    id: 'acdenHelios',
    name: 'ACDEN HELIOS',
    isActive: true
  },
  {
    id: 'bme',
    name: 'BME',
    isActive: true
  },
  {
    id: 'bouchier',
    name: 'BOUCHIER',
    isActive: true
  },
  {
    id: 'bvLab',
    name: 'BV LAB',
    isActive: true
  },
  {
    id: 'clearstreamEnergyServicesLp',
    name: 'CLEARSTREAM ENERGY SERVICES LP',
    isActive: true
  },
  {
    id: 'creStantecLtd',
    name: 'CRE STANTEC LTD',
    isActive: true
  },
  {
    id: 'finning',
    name: 'FINNING',
    isActive: true
  },
  {
    id: 'garda',
    name: 'GARDA',
    isActive: true
  },
  {
    id: 'genmecAclInc',
    name: 'GENMEC ACL INC',
    isActive: true
  },
  {
    id: 'graham',
    name: 'GRAHAM',
    isActive: true
  },
  {
    id: 'grahamMaintenanceServices',
    name: 'GRAHAM MAINTENANCE SERVICES',
    isActive: true
  },
  {
    id: 'grahamMckayLp',
    name: 'GRAHAM MCKAY LP',
    isActive: true
  },
  {
    id: 'iol',
    name: 'IMPERIAL OIL LIMITED',
    isActive: true
  },
  {
    id: 'kalTire',
    name: 'KAL TIRE',
    isActive: true
  },
  {
    id: 'kentz',
    name: 'KENTZ',
    isActive: true
  },
  {
    id: 'ketekGroup',
    name: 'KETEK GROUP',
    isActive: true
  },
  {
    id: 'mfm',
    name: 'MFM',
    isActive: true
  },
  {
    id: 'mikisewNorthAmerican',
    name: 'MIKISEW NORTH AMERICAN',
    isActive: true
  },
  {
    id: 'mikisewCrane',
    name: 'MIKISEW-CRANE',
    isActive: true
  },
  {
    id: 'mikisewIsos',
    name: 'MIKISEW-ISOS',
    isActive: true
  },
  {
    id: 'mistras',
    name: 'MISTRAS',
    isActive: true
  },
  {
    id: 'northAmericanEnterprisesLp',
    name: 'NORTH AMERICAN ENTERPRISES LP',
    isActive: true
  },
  {
    id: 'ocl',
    name: 'OCL',
    isActive: true
  },
  {
    id: 'paragonSoil',
    name: 'PARAGON SOIL',
    isActive: true
  },
  {
    id: 'sgsCanadaInc',
    name: 'SGS CANADA INC.',
    isActive: true
  },
  {
    id: 'soogadinFieldServices',
    name: 'SOOGADIN FIELD SERVICES',
    isActive: true
  },
  {
    id: 'spartanControls',
    name: 'SPARTAN CONTROLS',
    isActive: true
  },
  {
    id: 'sterlingCrane',
    name: 'STERLING CRANE',
    isActive: true
  },
  {
    id: 'stuartOlsonIndustrial',
    name: 'STUART OLSON INDUSTRIAL',
    isActive: true
  },
  {
    id: 'summit',
    name: 'SUMMIT',
    isActive: true
  },
  {
    id: 'tyco',
    name: 'TYCO',
    isActive: true
  },
  {
    id: 'wardsHydraulics',
    name: 'WARDS HYDRAULICS',
    isActive: true
  },
  {
    id: 'weirMinerals',
    name: 'WEIR MINERALS',
    isActive: true
  }
];
